/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ClientError } from '../model/clientError.model';
// @ts-ignore
import { OutgoingPaymentState } from '../model/outgoingPaymentState.model';
// @ts-ignore
import { PaymentMethodCode } from '../model/paymentMethodCode.model';
// @ts-ignore
import { PaymentType } from '../model/paymentType.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class OutgoingPaymentExportControllerService {

    protected basePath = 'http://localhost/assets-backend/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(@Inject(HttpClient) protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Inject(Configuration) @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param projectKey 
     * @param departmentId 
     * @param state 
     * @param type 
     * @param types 
     * @param contractId 
     * @param barterId 
     * @param year 
     * @param years 
     * @param sortDir 
     * @param sortedBy 
     * @param paymentTypes 
     * @param payoutDates 
     * @param payoutDateFrom 
     * @param payoutDateTo 
     * @param searchOtherSubject 
     * @param searchOtherSubjectId 
     * @param amountFrom 
     * @param amountTo 
     * @param note 
     * @param recipientId 
     * @param _export 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOutgoingPaymentExport(projectKey: string, departmentId?: number, state?: Array<OutgoingPaymentState>, type?: PaymentType, types?: Array<PaymentType>, contractId?: number, barterId?: number, year?: number, years?: Array<number>, sortDir?: string, sortedBy?: string, paymentTypes?: Array<PaymentMethodCode>, payoutDates?: Array<string>, payoutDateFrom?: string, payoutDateTo?: string, searchOtherSubject?: string, searchOtherSubjectId?: number, amountFrom?: number, amountTo?: number, note?: string, recipientId?: number, _export?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public getOutgoingPaymentExport(projectKey: string, departmentId?: number, state?: Array<OutgoingPaymentState>, type?: PaymentType, types?: Array<PaymentType>, contractId?: number, barterId?: number, year?: number, years?: Array<number>, sortDir?: string, sortedBy?: string, paymentTypes?: Array<PaymentMethodCode>, payoutDates?: Array<string>, payoutDateFrom?: string, payoutDateTo?: string, searchOtherSubject?: string, searchOtherSubjectId?: number, amountFrom?: number, amountTo?: number, note?: string, recipientId?: number, _export?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public getOutgoingPaymentExport(projectKey: string, departmentId?: number, state?: Array<OutgoingPaymentState>, type?: PaymentType, types?: Array<PaymentType>, contractId?: number, barterId?: number, year?: number, years?: Array<number>, sortDir?: string, sortedBy?: string, paymentTypes?: Array<PaymentMethodCode>, payoutDates?: Array<string>, payoutDateFrom?: string, payoutDateTo?: string, searchOtherSubject?: string, searchOtherSubjectId?: number, amountFrom?: number, amountTo?: number, note?: string, recipientId?: number, _export?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public getOutgoingPaymentExport(projectKey: string, departmentId?: number, state?: Array<OutgoingPaymentState>, type?: PaymentType, types?: Array<PaymentType>, contractId?: number, barterId?: number, year?: number, years?: Array<number>, sortDir?: string, sortedBy?: string, paymentTypes?: Array<PaymentMethodCode>, payoutDates?: Array<string>, payoutDateFrom?: string, payoutDateTo?: string, searchOtherSubject?: string, searchOtherSubjectId?: number, amountFrom?: number, amountTo?: number, note?: string, recipientId?: number, _export?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (projectKey === null || projectKey === undefined) {
            throw new Error('Required parameter projectKey was null or undefined when calling getOutgoingPaymentExport.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (departmentId !== undefined && departmentId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>departmentId, 'departmentId');
        }
        if (state) {
            state.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'state');
            })
        }
        if (type !== undefined && type !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>type, 'type');
        }
        if (types) {
            types.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'types');
            })
        }
        if (contractId !== undefined && contractId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractId, 'contractId');
        }
        if (barterId !== undefined && barterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>barterId, 'barterId');
        }
        if (year !== undefined && year !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>year, 'year');
        }
        if (years) {
            years.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'years');
            })
        }
        if (sortDir !== undefined && sortDir !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortDir, 'sortDir');
        }
        if (sortedBy !== undefined && sortedBy !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sortedBy, 'sortedBy');
        }
        if (paymentTypes) {
            paymentTypes.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'paymentTypes');
            })
        }
        if (payoutDates) {
            payoutDates.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'payoutDates');
            })
        }
        if (payoutDateFrom !== undefined && payoutDateFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>payoutDateFrom, 'payoutDateFrom');
        }
        if (payoutDateTo !== undefined && payoutDateTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>payoutDateTo, 'payoutDateTo');
        }
        if (searchOtherSubject !== undefined && searchOtherSubject !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>searchOtherSubject, 'searchOtherSubject');
        }
        if (searchOtherSubjectId !== undefined && searchOtherSubjectId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>searchOtherSubjectId, 'searchOtherSubjectId');
        }
        if (amountFrom !== undefined && amountFrom !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountFrom, 'amountFrom');
        }
        if (amountTo !== undefined && amountTo !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>amountTo, 'amountTo');
        }
        if (note !== undefined && note !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>note, 'note');
        }
        if (recipientId !== undefined && recipientId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>recipientId, 'recipientId');
        }
        if (_export !== undefined && _export !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>_export, 'export');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (BearerToken) required
        localVarCredential = this.configuration.lookupCredential('BearerToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*',
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/${this.configuration.encodeParam({name: "projectKey", value: projectKey, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/outgoing-payment/export`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
